import Skeleton from 'components/Skeleton';
import SkeletonGroup from 'components/Skeleton/SkeletonGroup';

const SwitchGroupSkeleton = () => (
  <div className="flex flex-col gap-y-4 md:gap-y-3">
    <Skeleton className="mb-2 h-5 w-24 rounded-2 md:mb-2" />
    {
      <SkeletonGroup
        items={3}
        skeleton={() => (
          <div className="flex gap-x-2">
            <Skeleton className="h-5 w-10 rounded-full" />
            <Skeleton className="h-5 w-full rounded-2" />
          </div>
        )}
      />
    }
  </div>
);

export default SwitchGroupSkeleton;
